import { type FC } from 'react';
import useMeasure from 'react-use-measure';
import cn from 'classnames';

import {
  type LeaderboardEntry,
  type LeagueTopListItemType,
} from '@/common/types/league';

import { WinnerPosition } from '../WinnerPosition/WinnerPosition';

import css from './styles.module.scss';

interface LeagueWinnersProps {
  list: LeagueTopListItemType[] | LeaderboardEntry[];
}

const LeagueWinners: FC<LeagueWinnersProps> = ({ list }) => {
  const [ref, { width }] = useMeasure();

  return (
    <div
      className={cn(
        'w-full h-[6.625rem] flex py-2 px-5 justify-between items-end mb-2',
        'name' in list[0] && list[0].name && css.topLeague,
      )}
    >
      {Array.from({ length: 3 }).map((_, index) => {
        const winnerData = list[index];

        return (
          <div
            ref={ref}
            key={`winner-${index}`}
            className={cn(
              'h-full flex flex-col items-center justify-end flex-1 gap-1',
              `${index === 0 ? 'order-2' : index === 1 ? 'order-1' : 'order-3'}`,
            )}
          >
            {winnerData && (
              <>
                <WinnerPosition
                  position={winnerData.position}
                  avatar={winnerData.avatar}
                  isVip={winnerData.isVip || false}
                />
                <span
                  style={{ maxWidth: width - 10 }}
                  className="leading-1.2 text-xs !text-white crop-long-text"
                >
                  {'firstName' in winnerData
                    ? `${winnerData.firstName} ${winnerData.lastName}`
                    : winnerData.name}
                </span>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export { LeagueWinners };
